import React, { useContext } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, makeStyles, Slide } from "@material-ui/core";
import CheckIcon from '@material-ui/icons/Check';
import CancelIcon from '@material-ui/icons/Cancel';
import { Theme } from '../contexts/themeContext.js';
import { GlobalTheme } from "../../layouts/theme";

const useStyles = makeStyles(() => ({
    dialog: {
        borderRadius: 10
    },
    title: {
        color: "red",
        fontWeight: "bold"
    }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const SaveWarningDialog = ({ open, onDisContinue, onContinue }) => {
    const { theme } = useContext(Theme);
    const currentTheme = GlobalTheme[theme];
    const classes = useStyles();

    return (
        <Dialog
            open={open}
            classes={{ paper: classes.dialog }}
            TransitionComponent={Transition}>
            <DialogTitle className={classes.title}>WARNING!</DialogTitle>
            <DialogContent dividers>
                <Typography variant="h6" style={{ textTransform: "none" }}>{'You will lose unsaved data if you navigate from current page. Are you sure you do not want to save the data?'}</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onContinue} variant="contained" color="primary" size="small" style={{ background: currentTheme.secondary, width: "80px" }} startIcon={<CheckIcon />} autoFocus>Yes</Button>
                <Button onClick={onDisContinue} variant="contained" color="secondary" size="small" style={{ width: "80px", marginRight: "10px" }} startIcon={<CancelIcon />}>No</Button>
            </DialogActions>
        </Dialog>
    );
};

export default SaveWarningDialog;
